import { render } from "./logos-list.vue?vue&type=template&id=f67d1204"
import script from "./logos-list.vue?vue&type=script&lang=js"
export * from "./logos-list.vue?vue&type=script&lang=js"

import "./logos-list.vue?vue&type=style&index=0&id=f67d1204&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__